<template>
    <div class="flex justify-end items-center gap-2 pt-4">
        <div
            v-if="currentPage !== 1"
            @click="$emit('changePage', currentPage - 1)"
            class="cursor-pointer flex justify-center h-[25px] px-0.5 min-w-[25px] items-center text-center">
            <i
                class="fal text-sm fa-chevron-left"
            />
        </div>

        <div
            v-if="showStart"
            @click="$emit('changePage', 1)"
            class="bg-white rounded-[4px] cursor-pointer h-[25px] px-0.5 min-w-[25px] flex justify-center items-center text-center text-sm shad px-0.5omin-w-sm"
            v-text="1">
        </div>

        <div
            v-if="showStartEllipsis"
            class="h-[25px] px-0.5 min-w-[25px] flex justify-center items-center text-center text-sm"
            v-text="'...'">
        </div>

        <div
            v-for="pageNumber in getPageNumbers"
            @click="$emit('changePage', pageNumber)"
            class="bg-white rounded-[4px] cursor-pointer h-[25px] px-0.5 min-w-[25px] flex justify-center items-center text-center text-sm shad px-0.5omin-w-sm"
            :class="{
                'outline-sn-orange outline outline-1': currentPage === pageNumber
            }"
            v-text="pageNumber"
        />

        <div
            v-if="showEndEllipsis"
            class="h-[25px] px-0.5 min-w-[25px] flex justify-center items-center text-center text-sm"
            v-text="'...'">
        </div>

        <div
            v-if="showEnd"
            @click="$emit('changePage', props.totalPages)"
            class="bg-white rounded-[4px] cursor-pointer h-[25px] px-0.5 min-w-[25px] flex justify-center items-center text-center text-sm shad px-0.5omin-w-sm"
            v-text="props.totalPages">
        </div>

        <div
            v-if="showNextChevron"
            @click="$emit('changePage', currentPage + 1)"
            class="cursor-pointer flex justify-center h-[25px] px-0.5 min-w-[25px] items-center text-center">
            <i
                class="fal text-sm fa-chevron-right"
            />
        </div>
    </div>
</template>

<script setup lang="ts">

const props = defineProps({
    totalPages: {
        type: Number,
        required: false,
    },
    currentPage: {
        type: Number,
        required: true,
    },
    hideNext: {
        type: Boolean,
        required: false,
    }
    // perPage: {
    //     type: Number,
    //     required: true
    // }
});

const getPageNumbers = computed(() => {
    if(!props.totalPages) {
        if(props.currentPage === 1) {
            if(props.hideNext) {
                return [props.currentPage];
            }
            return [props.currentPage, props.currentPage + 1];
        }
        if(props.hideNext) {
            return [props.currentPage - 1, props.currentPage];
        }
        return [props.currentPage - 1, props.currentPage, props.currentPage + 1];
    }
    if(props.totalPages <= 5) {
        let pageNumbers = [];
        for(let i = 1; i <= props.totalPages; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    }

    let pageNumbers = [props.currentPage];
    let i = 1;
    while(pageNumbers.length < 4) {
        if((props.currentPage + i) <= props.totalPages) {
            pageNumbers.push(props.currentPage + i);
        }
        if(pageNumbers.length === 4) {
            continue;
        }
        if((props.currentPage - i) > 0) {
            pageNumbers.push(props.currentPage - i);
        }

        i++;
    }

    return pageNumbers.sort(function(a,b) {
        return a > b ? 1 : -1;
    });
})

const showStart = computed(() => {
    return !getPageNumbers.value.includes(1);
});
const showStartEllipsis = computed(() => {
    return !getPageNumbers.value.includes(1) && !getPageNumbers.value.includes(2);
})
const showEnd = computed(() => {
    return props.totalPages && !getPageNumbers.value.includes(props.totalPages);
})
const showEndEllipsis = computed(() => {
    return props.totalPages && !getPageNumbers.value.includes(props.totalPages) && !getPageNumbers.value.includes(props.totalPages - 1);
})

const showNextChevron = computed(() => {
    // if(!props.totalPages) {
        // return props.perPage
    // }
    if(props.hideNext === true) {
        return false;
    }
    return props.currentPage !== props.totalPages
})

</script>